var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppinline = function SvgAppinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A98F",
    d: "M52.073 28.092v-11.29H27.518c-2.399 0-4.233 1.835-4.233 4.234V51.52c0 2.399 1.834 4.234 4.233 4.234h14.536c2.399 0 4.233-1.835 4.233-4.234V29.504h-7.056V22.87H26.107v-1.835c0-.706.565-1.411 1.411-1.411h13.124v8.467h11.431ZM43.606 51.52c0 .847-.564 1.411-1.411 1.411H27.518c-.846 0-1.41-.564-1.41-1.411v-4.093h17.357s0 4.093.141 4.093ZM35.14 24.282v9.456h8.467v12.278H26.107V24.282h9.032Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A98F",
    d: "M36.268 50.532c0 .847-.706 1.411-1.411 1.411-.847 0-1.412-.706-1.412-1.411 0-.847.706-1.411 1.412-1.411.705 0 1.41.564 1.41 1.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#08AA90",
    d: "M40.784 35.149v4.233h-11.29v-11.29h4.234v7.057h7.056Z"
  })));
};
export default SvgAppinline;